import * as React from 'react';

import { TableCell, TableRow } from 'components/table';

import { t } from 'utils/language';
import { ORGANIZATION_PROFILE_TYPE_BRAND } from 'utils/organization';

import type { OrganizationProfileType } from 'types';

type Props = {
  activeTab: string,
  hasFilters: boolean,
  profileType: OrganizationProfileType
};

const CampaignsTableEmptyRow = (
  {
    activeTab,
    profileType,
    hasFilters
  }: Props
): JSX.Element => {
  let message = profileType === ORGANIZATION_PROFILE_TYPE_BRAND ?
    t(`campaigns_table.empty_table_label.campaign_${activeTab}`) :
    t('campaigns_table.empty_table_label.default');

  if (hasFilters) {
    message = t('campaigns_table.empty_table_label.filters_enabled');
  }

  return (
    <TableRow>
      <TableCell width="fill">
        <div className="campaigns-table-empty-row">
          {message}
        </div>
      </TableCell>
    </TableRow>
  );
};

export default CampaignsTableEmptyRow;
